(() => {
  if (window.KKSetQuickViewReady) return;
  window.KKSetQuickViewReady = true;
  let opener = null;

  const closeDialog = (dialog) => {
    if (!dialog?.open) return;
    dialog.close();
    document.documentElement.classList.remove('kk-dialog-open');
    document.body.classList.remove('kk-dialog-open');
    opener?.focus();
    opener = null;
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-kk-set-open]');
    if (openButton) {
      const dialog = document.getElementById(openButton.dataset.kkSetOpen);
      if (!dialog) return;
      opener = openButton;
      document.documentElement.classList.add('kk-dialog-open');
      document.body.classList.add('kk-dialog-open');
      dialog.showModal();
      dialog.querySelector('[data-kk-set-close]')?.focus();
      return;
    }

    const closeButton = event.target.closest('[data-kk-set-close]');
    if (closeButton) closeDialog(closeButton.closest('dialog'));
  });

  document.addEventListener('cancel', (event) => {
    if (!event.target.matches('.kk-set-dialog')) return;
    event.preventDefault();
    closeDialog(event.target);
  }, true);

  document.addEventListener('click', (event) => {
    if (event.target.matches('.kk-set-dialog')) closeDialog(event.target);
  });
})();
